import { render, staticRenderFns } from "./PersonaView.vue?vue&type=template&id=44b2950a&scoped=true"
import script from "./PersonaView.vue?vue&type=script&lang=js"
export * from "./PersonaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2950a",
  null
  
)

export default component.exports